import script from "./EditService.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditService.vue?vue&type=script&setup=true&lang=ts"

import "./EditService.vue?vue&type=style&index=0&id=61a9bce2&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a9bce2"]])

export default __exports__